import { type EnabledTiersConfig } from "@clipboard-health/flag-attendance-policy";
import { isDefined } from "@clipboard-health/util-ts";
import { type ShiftArrivalEvent } from "@src/appV2/redesign/Tiers/api/schema";
import { addMinutes, isAfter, parseISO, startOfMinute } from "date-fns";

export function isArrivalOnTime(
  arrivalEvent: ShiftArrivalEvent,
  tierConfig: Pick<
    EnabledTiersConfig,
    | "lateForgivenessBookingLeadTimeThresholdInMinutes"
    | "lateForgivenessIfAfterAnotherShift"
    | "lateForgivenessGracePeriodInMinutes"
  >
): boolean {
  const {
    meta: {
      actualArrivalTime,
      start,
      clockInCreatedAt,
      bookingLeadTimeInMinutes,
      isAfterAnotherShift,
      manualOverride,
    },
  } = arrivalEvent;
  const {
    lateForgivenessBookingLeadTimeThresholdInMinutes,
    lateForgivenessIfAfterAnotherShift,
    lateForgivenessGracePeriodInMinutes,
  } = tierConfig;

  if (
    (isAfterAnotherShift && lateForgivenessIfAfterAnotherShift) ||
    bookingLeadTimeInMinutes < lateForgivenessBookingLeadTimeThresholdInMinutes ||
    manualOverride
  ) {
    return true;
  }

  const actualArrivalTimeStartOfMinute = isDefined(actualArrivalTime)
    ? startOfMinute(parseISO(actualArrivalTime))
    : undefined;

  const startTimeWithGracePeriod = addMinutes(parseISO(start), lateForgivenessGracePeriodInMinutes);

  return isDefined(actualArrivalTimeStartOfMinute)
    ? !isAfter(actualArrivalTimeStartOfMinute, startTimeWithGracePeriod)
    : !isAfter(parseISO(clockInCreatedAt), startTimeWithGracePeriod);
}
